import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import { LOGO } from "../../lib/site";
import SEO from "../../components/SEO";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls =
    "w-full border border-white/20 bg-white/5 text-white px-4 py-3.5 text-sm placeholder:text-white/40 focus:outline-none focus:border-rouge transition-colors duration-300";

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-5">
      <SEO title="Administration" />
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-10">
          <img src={LOGO} alt="Club Cycliste Le Boulou — logo officiel" className="h-24 w-auto bg-white px-3 py-2" />
        </Link>

        <form onSubmit={submit} data-testid="admin-login-form" className="bg-navy2 border border-white/10 p-8 sm:p-10">
          <h1 className="font-heading uppercase font-semibold tracking-tight text-white text-2xl mb-2">Administration</h1>
          <p className="text-white/50 text-sm mb-8">Gestion des actualités du site.</p>

          <div className="space-y-4">
            <div>
              <label htmlFor="admin-email" className="block font-heading uppercase tracking-wider text-xs text-white/60 mb-2">Email</label>
              <input id="admin-email" data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@clubcyclisteleboulou.fr" className={inputCls} />
            </div>
            <div>
              <label htmlFor="admin-password" className="block font-heading uppercase tracking-wider text-xs text-white/60 mb-2">Mot de passe</label>
              <input id="admin-password" data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} />
            </div>
          </div>

          {error && (
            <p data-testid="admin-login-error" className="mt-5 bg-rouge/15 border border-rouge/40 text-rouge text-sm px-4 py-3">{error}</p>
          )}

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="mt-7 w-full inline-flex items-center justify-center gap-2 bg-rouge text-white font-heading uppercase tracking-wider text-sm px-6 py-4 hover:bg-white hover:text-navy disabled:opacity-60 transition-[background-color,color] duration-300"
          >
            {submitting && <Loader2 size={16} className="animate-spin" />}
            Se connecter
          </button>
        </form>

        <Link to="/" className="block text-center mt-6 text-white/40 hover:text-white text-xs uppercase tracking-widest transition-colors">
          ← Retour au site
        </Link>
      </div>
    </div>
  );
}
